(() => {
  if (customElements.get('aotr-quick-add')) return;

  const register = () => {
    if (!window.theme?.AjaxProduct || customElements.get('aotr-quick-add')) return;

    class CardProductForm extends window.theme.AjaxProduct {
      async addItemFromForm(event) {
        event.preventDefault();
        if (this.loading) return;
        this.loading = true;
        const button = this.submitButton();
        button.disabled = true;
        button.classList.add('btn--loading');
        const errorText = this.form.querySelector('[name="aotr_cart_error"]').value;

        try {
          const response = await fetch(window.theme.routes.cartAdd, {
            method: 'POST',
            body: new FormData(this.form),
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          const product = await response.json();
          if (!response.ok || product.status) {
            this.error({ ...product, description: product.description || errorText });
            return;
          }
          this.success(product);
          if (!this.form.isConnected && window.theme.settings.cartType !== 'page') {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: { product, addToCartBtn: button }
            }));
          }
          if (document.body.classList.contains('template-cart')) window.location.reload();
        } catch {
          this.error({ description: errorText });
        } finally {
          this.loading = false;
          button.disabled = false;
          button.classList.remove('btn--loading');
          this.form.querySelector('.errors')?.setAttribute('role', 'alert');
        }
      }
    }

    class AotrQuickAdd extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const form = this.querySelector('form');
        if (form) this.controller = new CardProductForm(form, '.quick-product__btn');
      }
    }

    customElements.define('aotr-quick-add', AotrQuickAdd);
  };

  register();
  if (!customElements.get('aotr-quick-add')) {
    document.addEventListener('DOMContentLoaded', register, { once: true });
  }
})();
